export const adjustExecutorsData = data => {
  let newData = {
    id: data.companyId,
    date: {
      created: data.createdAt,
      updated: data.updatedAt,
    },
    archive: null,
    status: 'archive', // default value
  };

  newData.archive = data.archive;
  newData.status = data.archive ? 'archive' : 'active';
  newData.company = {
    subjectKey: data.subject && data.subject.subjectKey,
    inn: data.inn,
    email: data.email,
  };
  if (newData.company.subjectKey === 'physical') {
    newData.company.subjectShortName = 'ФЛ';
    let str = '';
    if (data.lastname) {
      str += data.lastname + ' ';
    }
    if (data.name) {
      str += data.name[0].toUpperCase() + '.';
    }
    if (data.patronymic) {
      str += data.patronymic[0].toUpperCase() + '.';
    }
    newData.company.name = str ? str : null;
  } else {
    if (newData.company.subjectKey === 'legal') {
      newData.company.subjectShortName = 'ЮЛ';
    } else if (newData.company.subjectKey === 'individ') {
      newData.company.subjectShortName = 'ИП';
    }
    newData.company.name = data.nameLegal;
  }
  newData.orders = {
    planned: data.ordersPlanned,
    archived: data.ordersArchived,
  };
  newData.photo = data.picture;
  return newData;
};

export const adjustExecutorsFiltersRequest = filters => {
  const { search = false } = filters;
  let newData = {};
  if (search) {
    newData.search = search;
  }
  return newData;
};
